import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm$info$cityMasterIn, _vm$userTag;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "user-info box"
  }, [_c("div", {
    staticClass: "section-header"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("用户基本信息")]), _c("section", [_c("el-divider", {
    attrs: {
      direction: "vertical"
    }
  }), _c("span", {
    staticClass: "label"
  }, [_vm._v("注册时间")]), _vm._v(" " + _vm._s(_vm.info.createTime) + " ")], 1), _c("section", [_c("el-divider", {
    attrs: {
      direction: "vertical"
    }
  }), _c("span", {
    staticClass: "label"
  }, [_vm._v("备注")]), _vm._v(_vm._s(_vm.info.remark) + " "), _c("i", {
    staticClass: "el-icon-edit edit-icon wlc-pointer",
    on: {
      click: _vm.showRemark
    }
  })], 1)]), _c("div", {
    staticClass: "details-box flex"
  }, [_c("wlc-upload-image", {
    attrs: {
      width: "120px",
      height: "120px",
      url: _vm.info.avatar,
      preview: true,
      multimediaType: "userProfilePic"
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.info, "avatar", $event);
      }
    }
  }), _c("div", {
    staticClass: "details"
  }, [_c("div", {
    staticClass: "from"
  }, [_vm._v(" 来自： "), _vm.info.scene == 1 ? _c("span", [_vm._v("用户裂变")]) : _vm.info.scene == 2 && (_vm$info$cityMasterIn = _vm.info.cityMasterInfo) !== null && _vm$info$cityMasterIn !== void 0 && _vm$info$cityMasterIn.name ? _c("span", [_vm._v("城市大使 "), _vm.info.cityMasterInfo.name ? _c("span", [_vm._v(" - " + _vm._s(_vm.info.cityMasterInfo.name) + " ")]) : _vm._e(), _vm.info.cityMasterInfo.percent ? _c("span", [_vm._v(" - 开发准确率：" + _vm._s(_vm.info.cityMasterInfo.percent) + "% ")]) : _vm._e(), _vm.info.cityMasterInfo.remark ? _c("span", [_vm._v(" - " + _vm._s(_vm.info.cityMasterInfo.remark) + " ")]) : _vm._e()]) : _c("span", [_vm._v("自然用户")]), _c("span", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm.info.user_type == 1 ? _c("el-tag", {
    attrs: {
      size: "mini",
      type: "warning"
    }
  }, [_vm._v("充值用户 ")]) : _vm._e(), _vm.info.user_type == 3 ? _c("el-tag", {
    attrs: {
      size: "mini",
      type: "warning"
    }
  }, [_vm._v("季度用户 ")]) : _vm._e(), _vm.info.user_type == 0 ? [_vm.info.isRelease == 2 ? _c("el-tag", {
    attrs: {
      size: "mini",
      type: "success"
    }
  }, [_vm._v("房东 ")]) : _vm.info.occupation ? _c("el-tag", {
    attrs: {
      size: "mini",
      type: "primary"
    }
  }, [_vm._v("房客 ")]) : _c("el-tag", {
    attrs: {
      size: "mini",
      type: "info"
    }
  }, [_vm._v("游客")])] : _vm._e()], 2), _c("span", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm.info.landlord_status == 1 ? _c("el-tag", {
    attrs: {
      size: "mini"
    }
  }, [_vm._v("房主会员待审核")]) : _vm._e(), _vm.info.landlord_status == 2 ? _c("el-tag", {
    attrs: {
      size: "mini"
    }
  }, [_vm._v("房主会员")]) : _vm._e(), _vm.info.tenant_status == 1 ? _c("el-tag", {
    attrs: {
      size: "mini",
      type: "info"
    }
  }, [_vm._v("房客会员待审核")]) : _vm._e(), _vm.info.tenant_status == 2 ? _c("el-tag", {
    attrs: {
      size: "mini",
      type: "info"
    }
  }, [_vm._v("房客会员")]) : _vm._e()], 1)]), _c("div", {
    staticClass: "ip-facility"
  }, [_c("span", [_vm._v(_vm._s(_vm.info.appInfo && _vm.info.appInfo.phoneBrand) + " - ")]), _c("span", [_vm._v(_vm._s(_vm.info.appInfo && _vm.info.appInfo.phoneModel))])]), _c("div", {
    staticClass: "device-risk"
  }, [_vm.deviceRisk.risk_code ? _c("div", {
    staticClass: "row"
  }, [_vm.deviceRisk.risk_code.length ? _c("div", {
    staticClass: "col",
    class: {
      "col-gray": _vm.deviceRisk.risk_level == -1
    }
  }, [_c("span", [_vm._v("数盟 - " + _vm._s(_vm.deviceRisk.risk_code.join("/")))])]) : _vm._e(), _vm.deviceRisk.risk_code.length && (_vm.deviceRisk.status == 1 || _vm.deviceRisk.status == 2) ? _c("span", {
    staticClass: "line"
  }, [_vm._v("|")]) : _vm._e(), _vm.deviceRisk.status == 1 ? _c("div", {
    staticClass: "col"
  }, [_vm._v(" 高危标记设备 ")]) : _vm._e(), _vm.deviceRisk.status == 2 ? _c("div", {
    staticClass: "col"
  }, [_vm._v(" 高危感知源 "), _vm.deviceRisk.status_remark ? _c("span", [_vm._v(" : " + _vm._s(_vm.deviceRisk.status_remark) + " ")]) : _vm._e()]) : _vm._e(), _vm.deviceRisk.perception_code ? _c("span", {
    staticClass: "line"
  }, [_vm._v("|")]) : _vm._e(), _vm.deviceRisk.perception_code ? _c("div", {
    staticClass: "col"
  }, [_vm._v(" 高危Wi-Fi感知 "), _vm.getPerceptionCodeName ? _c("span", [_vm._v(": " + _vm._s(_vm.getPerceptionCodeName))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm.deviceRisk.relevance_account > 1 ? _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col user-info-list"
  }, [_c("span", [_vm._v(" 数盟 - 关联账号 * " + _vm._s(_vm.deviceRisk.relevance_account) + "： ")]), _c("wlc-user-list-pop", {
    attrs: {
      list: _vm.deviceRisk.user_list
    }
  })], 1), _vm.deviceRisk.relevance_account > 1 && _vm.deviceRisk.status == 0 && !_vm.deviceRisk.perception_code ? _c("div", {
    staticClass: "col"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      type: "danger",
      plain: ""
    },
    on: {
      click: _vm.goDeviceList
    }
  }, [_vm._v("设高危 ")])], 1) : _vm._e()]) : _vm._e()]), _c("div", {
    staticClass: "mtb4 wlc-f-c"
  }, [_c("wlc-user-pop", {
    staticStyle: {
      display: "inline-block",
      "margin-right": "10px"
    },
    attrs: {
      info: _vm.info.userInfo
    },
    on: {
      saveRemark: _vm.saveRemark
    }
  }), _c("span", [_vm.info.loginType == "one_click_login" ? _c("el-tag", {
    staticClass: "mr8",
    attrs: {
      size: "small",
      type: "success"
    }
  }, [_vm._v("一键登录")]) : _vm._e(), _vm.info.appleUnionid ? _c("el-tag", {
    staticClass: "mr8",
    attrs: {
      size: "small",
      type: "success"
    }
  }, [_vm._v("苹果登录")]) : _vm._e(), _vm.info.unionid ? _c("el-tag", {
    staticClass: "mr8",
    attrs: {
      size: "small",
      type: "success"
    }
  }, [_vm._v("微信登录")]) : _vm._e()], 1), _vm.info.phoneCounty && _vm.info.phoneCounty != "中国" ? _c("el-tag", {
    staticClass: "mr8 wlc-important-tag",
    attrs: {
      size: "small",
      type: "danger"
    }
  }, [_vm._v(_vm._s(_vm.info.phoneCounty) + " ")]) : _vm._e(), _c("el-input", {
    staticStyle: {
      width: "200px"
    },
    attrs: {
      size: "mini",
      disabled: ""
    },
    model: {
      value: _vm.info.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.info, "phone", $$v);
      },
      expression: "info.phone"
    }
  }, [_c("el-button", {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: _vm.info.phone,
      expression: "info.phone",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: _vm.onCopy,
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: _vm.onError,
      expression: "onError",
      arg: "error"
    }],
    attrs: {
      slot: "append",
      icon: "el-icon-document-copy"
    },
    slot: "append"
  }, [_vm._v("复制 ")])], 1)], 1), _c("div", [_vm.info.logoutCount > 0 ? _c("el-tag", {
    attrs: {
      size: "small",
      type: "danger"
    }
  }, [_vm._v("注销+" + _vm._s(_vm.info.logoutCount) + " ")]) : _vm._e()], 1)]), (_vm$userTag = _vm.userTag) !== null && _vm$userTag !== void 0 && _vm$userTag.length ? _c("div", {
    staticClass: "user-tag"
  }, [_c("wlc-user-table-tag", {
    attrs: {
      height: "120px",
      width: "320px",
      userId: _vm.info.id,
      list: _vm.userTag
    }
  })], 1) : _vm._e(), _c("wlc-radar-chart", {
    attrs: {
      id: _vm.info.id
    }
  })], 1), _c("el-dialog", {
    attrs: {
      visible: _vm.remarkVisible,
      width: "320px",
      center: ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.remarkVisible = $event;
      }
    }
  }, [_c("div", {
    staticClass: "wlc-f-c",
    staticStyle: {
      "justify-content": "center"
    },
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" 修改备注 ")]), _c("el-input", {
    attrs: {
      placeholder: "请输入备注"
    },
    model: {
      value: _vm.remark,
      callback: function callback($$v) {
        _vm.remark = $$v;
      },
      expression: "remark"
    }
  }), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.remarkVisible = false;
      }
    }
  }, [_vm._v("取消")]), _c("el-button", {
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.confirmClose
    }
  }, [_vm._v("确定")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };